module.exports = __webpack_public_path__ + "static/media/ITC-OfficinaSansITCPro-Book.bae54c34.woff";